// import { StrictMode } from 'react'
// import { createRoot } from 'react-dom/client'
// import './index.css'
// import App from './App.jsx'

// createRoot(document.getElementById('root')).render(
//   <StrictMode>
//     <App />
//   </StrictMode>,
// )



import React from 'react';
import { createRoot } from 'react-dom/client'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals'
 
import './des.css';
 
const rootElement = document.getElementById('root');
 
const root = createRoot(rootElement);
 
root.render(
  // <BrowserRouter>
  //   <App />
  // </BrowserRouter>
  <App />
);
// reportWebVitals();
 

 

 